module.exports = __webpack_public_path__ + "img/banner.906041e7.png";